<script setup lang="ts">
import { computed, ref, toRefs, watch } from 'vue';
import { useImages } from '@ilteducation/images';
import type { Category } from '@ilteducation/content-ref-data-types';

const props = withDefaults(
  defineProps<{
    category?: Category;
    size?: number;
    alt?: string;
  }>(),
  {
    category: undefined,
    size: 64,
    alt: undefined,
  },
);

const { category, size, alt } = toRefs(props);
const { getImageUrlByImageId } = useImages();

const imageUrl = ref<string | undefined>(undefined);

const glyphSize = computed(() => Math.round(size.value * 0.4));

watch(
  category,
  async () => {
    imageUrl.value = category.value?.imageId ? await getImageUrlByImageId(category.value.imageId) : undefined;
  },
  { immediate: true },
);
</script>

<template>
  <v-sheet
    v-if="imageUrl"
    tag="img"
    :src="imageUrl"
    :height="size"
    :width="size"
    :alt="alt"
    class="rounded-circle category-icon"
  />
  <v-sheet
    v-else-if="category?.icon"
    :height="size"
    :width="size"
    :color="category.color || 'primary'"
    class="rounded-circle d-flex align-center justify-center"
  >
    <v-icon aria-hidden="true" color="white" :size="glyphSize" :icon="`fa:${category.icon}`" />
  </v-sheet>
  <v-sheet
    v-else
    :height="size"
    :width="size"
    class="rounded-circle d-flex align-center justify-center bg-surface-container"
  >
    <v-icon aria-hidden="true" color="on-surface" :size="glyphSize" icon="fa:fas fa-file-lines" />
  </v-sheet>
</template>

<style scoped lang="scss">
.category-icon {
  object-fit: cover;
}
</style>
